import { useState, useEffect } from "react";
import { useSearchParams, useNavigate } from 'react-router-dom';

import { getToken } from "../../utils/api";
import ErrorDialog from '../ErrorDialog/ErrorDialog';


function Callback() {
    const [params] = useSearchParams();
    const navigate = useNavigate();

    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    const clearError = () => {
        setErrorMessage(null);
        navigate('/login');
    };

    useEffect(() => {
        const error = params.get('error');

        if(error) {
            setErrorMessage(error);
            return;
        }

        const state = localStorage.getItem('state');

        if(state) {
            getToken(state)
                .then((data) => {
                    localStorage.setItem('token', data.token);
                    navigate('/');
                })
                .catch(() => {
                    setErrorMessage("Invalid user.");
                });
        }
        else {
            setErrorMessage("Invalid state.");
        }
    }, [params, navigate]);

    return (
        <ErrorDialog message={errorMessage} onErrorDisplay={clearError} />
    );
}

export default Callback;